<template>
  <div v-if="isShowUpgradePopup">
    <!-- Развёрнутый сайдбар-->
    <div
      v-if="isOpenSideBar"
      :class="$style.upgradeCard"
    >
      <div
        v-if="userRights.owner"
        :class="[$style.btns]"
      >
        <div
          v-if="discount"
          :class="[$style.upgradeCard_btn, discount ? $style.discount : '']"
          @click="upgradeClick()"
        >
          <b>
            - <span v-if="discount.isFixedDiscount">$ </span>
            {{ discount.percent }}
          </b>
          <i> <span v-if="!discount.isFixedDiscount">%</span> </i>
          <i v-if="discount.couponValidDays">
            {{ discount.coupon_till }} <b>{{ discount.tillDate }}</b>
          </i>
        </div>

        <div
          id="gp_autotest_sidebar_upgrade_button"
          :class="$style.upgradeCard_btn"
          @click="upgradeClick()"
        >
          {{ upgrade.btnName }}
        </div>
      </div>

      <div :class="$style.upgradeCard_txt">
        <span> {{ upgrade.txt }} </span>
        <div
          v-if="planLabel"
          :class="$style.upgradeCard_planLabel"
        >
          <span>{{ planLabel }}</span>
        </div>
        <tooltip
          :content="upgrade.tooltip"
          :class="$style.tooltips"
        >
          <template #body>
            <svg-sprite
              :name="'info'"
              :size="20"
              :class="$style.upgradeCard_icon"
            />
          </template>
        </tooltip>
      </div>
    </div>

    <!-- Свёрнутый сайдбар-->
    <div
      v-else
      id="gp_autotest_sidebar_upgrade_banner_collapsed"
      :class="$style.upgradeCollapsedWrapper"
      @click="upgradeClick()"
    >
      <div :class="$style.upgradeCollapsed">
          <span :class="$style.upgradeCollapsed_days">
          {{ upgrade.txt }}
        </span>
        <div :class="$style.upgradeCollapsed_btn">
          {{ upgrade.btnName.split(' ')[0] }}
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import plansModel from '../../../models/plans';
import Tooltip from '../../common/VueComponents/tooltips/tooltip.vue';
import SvgSprite from '../../common/VueComponents/VueIcon/svgSprite.vue';

export default {
  name: 'UpgradeButton',
  components: { Tooltip, SvgSprite },
  props: {
    isOpenSideBar: { type: Boolean, required: true },
    isShowUpgradePopup: { type: Boolean, required: true },
    userRights: { type: Object, required: true },
  },
  emits: [
    'upgradeClick',
  ],
  data() {
    return {
      discount: false,
      upgrade: {
        tooltip: (this.userRights.owner)
          ? __('trial_day_owner_left_text')
          : __('trial_day_member_left_text'),
        btnName: __('common_upgrade'),
        txt: null,
      },
    };
  },

  computed: {
    daysLeft() {
      let dayLeft = moment(plansModel.getExpiresDate()).subtract(4, 'hour').diff(moment(), 'days');

      if (dayLeft <= 0) {
        dayLeft = moment(plansModel.getExpiresDate()).diff(moment(), 'hours') > 0 ? 1 : 0;
      } else {
        dayLeft++;
      }

      return dayLeft;
    },
    planLabel() {
      if (!user.accountPlanData) {
        return '';
      }
      if (user.accountPlanData.is_trial) {
        const businessPlan = (user.paymentPlans || []).find(plan =>
          plan.plan_title_locale === 'business'
          || plan.name === 'business'
          || plan.plan_name === 'business',
        );
        if (businessPlan) {
          const rawName = businessPlan.plan_name || businessPlan.name || 'business';
          return rawName.charAt(0).toUpperCase() + rawName.slice(1);
        }
        return '';
      }
      return user.accountPlanData.name || '';
    },
  },
  created() {
    this.updateDiscount();
    this.upgrade.txt = __('trial_day_left', { dayLeft: this.daysLeft });
  },

  mounted() {
  },
  methods: {
    upgradeClick() {
      this.$emit('upgradeClick');
    },
    updateDiscount() {
      const hasDiscount = user.affiliate && user.affiliate.isStillValid && user.affiliate.percent && user.affiliate.coupon;

      if (!hasDiscount) {
        this.discount = false;

        return;
      }

      const discount = {
        isFixedDiscount: user.affiliate.isFixedDiscount,
        percent: user.affiliate.percent,
        couponValidDays: user.affiliate.couponValidDays,
        tillDate: this.tillDateDiscountLocale(),
        coupon_till: __('coupon_till'),
      };

      this.discount = discount;
    },
    getMomentString(locale, month, day) {
      const momentPart = moment(user.affiliate.startTime).add(user.affiliate.couponValidDays, 'day');

      return `${momentPart.locale(locale).format(month).toUpperCase()} ${momentPart.locale(locale).format(day)}`;
    },

    tillDateDiscountLocale() {
      const { locale } = user;

      switch (locale) {
        case 'kr':
          return this.getMomentString('ko', 'MMM', 'Do');

        case 'ru': {
          const momentPart = moment(user.affiliate.startTime).add(user.affiliate.couponValidDays, 'day');
          let month = momentPart.locale(locale).format('MMM').toUpperCase();
          const day = momentPart.locale(locale).format('Do');

          month = month.length === 4 ? month.split('.')[0] : month.substr(0, 3);

          return `${day} ${month}`;
        }

        case 'es':
          return this.getMomentString(locale, 'MMM', 'D');

        case 'pt':
          return this.getMomentString(locale, 'MMM.', 'D');

        case 'en':
          return this.getMomentString(locale, 'MMM.', 'Do');

        case 'de':
          return this.getMomentString(locale, 'MMM', 'D');

        default:
          return this.getMomentString(locale, 'MMM', 'Do');
      }
    },
  },
};

</script>

<style module src="../style.less" lang="less"></style>
